"use client";

/**
 * Sort picker for the listings page - a thin wrapper around the shared
 * SortPicker (dropdown on desktop, bottom sheet on mobile) with the
 * listings-specific option set.
 */

import SortPicker, { type SortOption } from "@/components/SortPicker";

const SORTS: SortOption[] = [
  { value: "newest", key: "listings.sort.newest" },
  { value: "price", key: "listings.sort.price" },
  { value: "price_desc", key: "listings.sort.price_desc" },
  { value: "ppm", key: "listings.sort.ppm" },
  { value: "best_deal", key: "listings.sort.best_deal" },
  { value: "yield", key: "listings.sort.yield" },
];

// A search by photo's list (?photo=) adds its own order: best match first.
const LOOK: SortOption = { value: "look", key: "listings.sort.look" };

interface Props {
  value: string;
  onChange: (value: string) => void;
  /** Commercial premises and garages carry no valuation: "best deal"
   *  and "yield" would order them by nothing. */
  noValuation?: boolean;
  /** The page lists a photo's lookalikes: offer their own order too. */
  withLook?: boolean;
}

const NO_VALUATION_SORTS = SORTS.filter((s) => s.value !== "best_deal" && s.value !== "yield");

export default function ListingsSortPicker({ value, onChange, noValuation = false, withLook = false }: Props) {
  const base = noValuation ? NO_VALUATION_SORTS : SORTS;
  return <SortPicker value={value} onChange={onChange} options={withLook ? [LOOK, ...base] : base} />;
}
